import { Box, Grid, MenuItem, TextField, Button, Typography, Stack } from '@mui/material';
import { Select } from '../../../shared/components/ui/Select';
import { useReport } from '../context';

const reportTypes = [
  { value: 'Moradores', label: 'Moradores' },
  { value: 'Visitantes', label: 'Visitantes' },
  { value: 'Reservas', label: 'Reservas' },
];

const periods = [
  { value: 'Último mês', label: 'Último mês' },
  { value: 'Este mês', label: 'Este mês' },
  { value: 'Personalizado', label: 'Personalizado' },
];

export function ReportFilters() {
  const { filters, setFilters, isLoading } = useReport();

  const handleChange = (field: string, value: any) => {
    setFilters({ ...filters, [field]: value });
  };

  const handleApply = () => {
    setFilters({ ...filters }); // Só força atualização, mas o React Query já busca ao mudar filtros
  };

  const handleClear = () => {
    setFilters({ type: 'Moradores', period: 'Último mês', startDate: '', endDate: '' });
  };

  return (
    <Box sx={{ background: '#fff', borderRadius: 3, p: 3, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={3}>
          <Typography fontSize={16} fontWeight={700} color="#23272E" lineHeight={1.2} mb={1}>Tipo de Relatório</Typography>
          <Select
            fullWidth
            value={filters.type}
            onChange={e => handleChange('type', e.target.value)}
            displayEmpty
          >
            {reportTypes.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography fontSize={16} fontWeight={700} color="#23272E" lineHeight={1.2} mb={1}>Período</Typography>
          <Select
            fullWidth
            value={filters.period}
            onChange={e => handleChange('period', e.target.value)}
            displayEmpty
          >
            {periods.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography fontSize={16} fontWeight={700} color="#23272E" lineHeight={1.2} mb={1}>Data Inicial</Typography>
          <TextField
            fullWidth
            label="Data Inicial"
            type="date"
            value={filters.startDate || ''}
            onChange={e => handleChange('startDate', e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography fontSize={16} fontWeight={700} color="#23272E" lineHeight={1.2} mb={1}>Data Final</Typography>
          <TextField
            fullWidth
            label="Data Final"
            type="date"
            value={filters.endDate || ''}
            onChange={e => handleChange('endDate', e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" mt={2}>
    <Stack direction="row" gap={1}>
      <Button variant="outlined" onClick={handleClear}>Limpar</Button>
      <Button variant="contained" onClick={handleApply} disabled={isLoading}>Aplicar Filtros</Button>
    </Stack>
  </Box>
    </Box>
  );
} 